import React, { useEffect, useState } from 'react';
import axios from 'axios';
import configApi from '../../config';

const ActionableInsights = () => {
    const [context, setContext] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const token = localStorage.getItem("token");
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    useEffect(() => {
        const fetchContext = async () => {
            try {
                const response = await axios.get(`${configApi.apiEndpoint}/api/Stats/DashboardContext`, config);
                setContext(response.data);
            } catch (error) {
                console.error('Error fetching dashboard context:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchContext();
    }, []);

    if (isLoading) {
        return (
            <div className="row gx-4 gy-4 mb-4">
                {[1, 2, 3, 4].map(i => (
                    <div key={i} className="col-md-3 col-sm-6">
                        <div className="metric-card w-100 p-3">
                            <div className="skeleton-circle" style={{ width: '40px', height: '40px' }}></div>
                            <div className="metric-data gap-2 w-100">
                                <div className="skeleton-box" style={{ width: '40%', height: '12px' }}></div>
                                <div className="skeleton-box" style={{ width: '80%', height: '20px' }}></div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    if (!context) return null;

    return (
        <div className="row gx-4 gy-4 mb-4">
            {/* 1. Upcoming Week Occupancy */}
            <div className="col-md-3 col-sm-6">
                <div className="metric-card w-100 p-3 h-100">
                    <div className="metric-icon d-flex align-items-center justify-content-center rounded-circle mb-3" style={{ width: '40px', height: '40px', fontSize: '1.2rem', backgroundColor: '#e2f0d9', color: '#2e7d32' }}>
                        <i className="bi bi-calendar-week m-0"></i>
                    </div>
                    <div className="metric-data gap-1 w-100">
                        <span style={{ fontSize: '0.8rem', margin: 0 }}>Nasledovných 7 dní</span>
                        <h4 style={{ margin: 0, fontSize: '1.2rem', fontWeight: 600 }}>{context.upcomingOccupancy?.ratePercentage ?? context.upcomingOccupancy?.RatePercentage}% obsadené</h4>
                        <div className="progress mt-1" style={{ height: '6px' }}>
                            <div className="progress-bar bg-success" role="progressbar" style={{ width: `${context.upcomingOccupancy?.ratePercentage ?? context.upcomingOccupancy?.RatePercentage}%` }}></div>
                        </div>
                        <span style={{ fontSize: '0.75rem', marginTop: '4px' }}>{context.upcomingOccupancy?.occupiedTerms ?? context.upcomingOccupancy?.OccupiedTerms} / {context.upcomingOccupancy?.totalTerms ?? context.upcomingOccupancy?.TotalTerms} termínov</span>
                    </div>
                </div>
            </div>

            {/* 2. Free Slots Tomorrow */}
            <div className="col-md-3 col-sm-6">
                <div className="metric-card w-100 p-3 h-100">
                    <div className="metric-icon d-flex align-items-center justify-content-center rounded-circle mb-3" style={{ width: '40px', height: '40px', fontSize: '1.2rem', backgroundColor: '#e3f2fd', color: '#1565c0' }}>
                        <i className="bi bi-clock-history m-0"></i>
                    </div>
                    <div className="metric-data gap-1 w-100">
                        <span style={{ fontSize: '0.8rem', margin: 0 }}>Voľné termíny na zajtra</span>
                        <h4 style={{ margin: 0, fontSize: '1.4rem', fontWeight: 600 }}>{context.freeSlotsTomorrow ?? context.FreeSlotsTomorrow}</h4>
                        <span style={{ fontSize: '0.75rem', marginTop: '4px', color: (context.freeSlotsTomorrow ?? context.FreeSlotsTomorrow) > 0 ? '#1565c0' : 'var(--cadet-gray)' }}>
                            {(context.freeSlotsTomorrow ?? context.FreeSlotsTomorrow) > 0 ? 'Máte ešte voľno' : 'Zajtra je plno'}
                        </span>
                    </div>
                </div>
            </div>

            {/* 3. Monthly Revenue */}
            <div className="col-md-3 col-sm-6">
                <div className="metric-card w-100 p-3 h-100">
                    <div className="metric-icon d-flex align-items-center justify-content-center rounded-circle mb-3" style={{ width: '40px', height: '40px', fontSize: '1.2rem', backgroundColor: '#fff3e0', color: '#ef6c00' }}>
                        <i className="bi bi-currency-euro m-0"></i>
                    </div>
                    <div className="metric-data gap-1 w-100">
                        <span style={{ fontSize: '0.8rem', margin: 0 }}>Zisk tento mesiac</span>
                        <h4 style={{ margin: 0, fontSize: '1.4rem', fontWeight: 600 }}>{context.currentMonthlyRevenue ?? context.CurrentMonthlyRevenue} €</h4>
                        <span style={{ fontSize: '0.75rem', marginTop: '4px' }}>Len zúčastnené rezervácie</span>
                    </div>
                </div>
            </div>

            {/* 4. No-Show Tracking */}
            <div className="col-md-3 col-sm-6">
                <div className="metric-card w-100 p-3 h-100">
                    <div className="metric-icon d-flex align-items-center justify-content-center rounded-circle mb-3" style={{ width: '40px', height: '40px', fontSize: '1.2rem', backgroundColor: '#fce4ec', color: '#c2185b' }}>
                        <i className="bi bi-exclamation-triangle m-0"></i>
                    </div>
                    <div className="metric-data gap-1 w-100">
                        <span style={{ fontSize: '0.8rem', margin: 0 }}>Nedostavenia / zrušené</span>
                        <h4 style={{ margin: 0, fontSize: '1.2rem', fontWeight: 600, color: '#c2185b' }}>{context.noShowTracking?.ratePercentage ?? context.noShowTracking?.RatePercentage}%</h4>
                        <span style={{ fontSize: '0.75rem', marginTop: '4px' }}>
                            Ušlý zisk: <strong>{context.noShowTracking?.estimatedLostRevenue ?? context.noShowTracking?.EstimatedLostRevenue} €</strong>
                        </span>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default ActionableInsights;
